(() => {
  if (!document.body.matches('.index, .collection')) return;
  const root = document.getElementById('MainContent');
  if (!root) return;
  const selector = 'product-card[data-kiin-swatch-card]';
  const pending = new Set();
  const widths = new WeakMap();
  let frame;
  const queue = (card) => {
    if (!card || !root.contains(card)) return;
    pending.add(card);
    if (!frame) frame = requestAnimationFrame(flush);
  };
  const resize = new ResizeObserver((entries) => {
    entries.forEach(({ target, contentRect }) => {
      if (widths.get(target) === contentRect.width) return;
      widths.set(target, contentRect.width);
      queue(target.closest(selector));
    });
  });
  const update = (card) => {
    const productLink = card.querySelector('[ref="productTitleLink"]');
    if (!productLink) return;
    const href = productLink.getAttribute('href')?.trim();
    if (!href) return;
    const title = productLink.getAttribute('aria-label') || productLink.textContent.trim();
    card.querySelectorAll('.fd-options-swatch__options').forEach((list) => {
      const items = [...list.children].filter((item) => item.matches('a.pg-product'));
      if (!items.length) return;
      const availableWidth = list.parentElement.clientWidth;
      const limit = items.length > 4 && availableWidth < 174 ? 3 : 4;
      const visible = new Set(items.slice(0, limit));
      const active = items.find((item) => item.classList.contains('active'))
        || items.find((item) => new URL(item.href).pathname === new URL(href, location.origin).pathname);
      if (active && !visible.has(active)) {
        visible.delete(items[limit - 1]);
        visible.add(active);
      }
      list.classList.add('kiin-card-swatches');
      items.forEach((item) => item.toggleAttribute('data-kiin-swatch-hidden', !visible.has(item)));
      let more = list.querySelector(':scope > .kiin-card-swatches__more');
      const remaining = items.length - visible.size;
      if (remaining > 0) {
        if (!more) {
          more = document.createElement('a');
          more.className = 'kiin-card-swatches__more';
          more.addEventListener('click', (event) => event.stopPropagation());
          list.append(more);
        }
        const text = '+' + remaining + ' ' + card.dataset.kiinSwatchMore;
        if (more.textContent !== text) more.textContent = text;
        if (more.getAttribute('href') !== href) more.setAttribute('href', href);
        more.setAttribute('aria-label', card.dataset.kiinSwatchLabel + ' (' + items.length + '): ' + title);
      } else if (more) more.remove();
      const sizing = list.parentElement;
      if (!widths.has(sizing)) {
        widths.set(sizing, sizing.clientWidth);
        resize.observe(sizing);
      }
    });
  };
  const collect = (node) => {
    if (!(node instanceof Element)) return;
    queue(node.closest(selector));
    node.querySelectorAll(selector).forEach(queue);
  };
  function flush() {
    frame = undefined;
    const cards = [...pending];
    pending.clear();
    cards.forEach((card) => {
      if (card.isConnected) update(card);
    });
  }
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') {
        if (record.target.matches('a.pg-product')) queue(record.target.closest(selector));
        return;
      }
      queue(record.target.closest?.(selector));
      record.addedNodes.forEach(collect);
    });
  });
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  collect(root);
})();
